(function(angular) {
    'use strict';

    var app = angular.module('asSupplyMgr');

    app.service('clusterApi', [
        '$http',
        '$q',
        function($http, $q) {
            this.getList = () => {
                let url = '/supply/inventory/clusters/list';

                return $q((resolve, reject) => {
                    $http.get(url).then(
                        res => {
                            resolve(res.data);
                        },
                        res => {
                            reject({ code: res.data.errorCode, message: res.data.message });
                        }
                    );
                });
            };

            this.create = function(data) {
                let url = '/supply/inventory/clusters/create';

                return $q(function(resolve, reject) {
                    $http.post(url, data).then(
                        // success
                        function(res) {
                            if (res.data.status === 'success') {
                                resolve(res.data.message);
                            } else {
                                reject(res.data.message);
                            }
                        },
                        // error
                        function(res) {
                            reject("Request error");
                        }
                    );
                });
            };

            this.delete = id => {
                let url = `/supply/inventory/clusters?_id=${id}`;

                return $q((resolve, reject) => {
                    $http.delete(url).then(
                        res => {
                            resolve(res);
                        },
                        res => {
                            reject(res);
                        }
                    );
                });
            };
        },
    ]);
})(window.angular);
